import { render, staticRenderFns } from "./CharityInvolvementDonations.vue?vue&type=template&id=ee0a1d20&scoped=true"
import script from "./CharityInvolvementDonations.vue?vue&type=script&lang=js"
export * from "./CharityInvolvementDonations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee0a1d20",
  null
  
)

export default component.exports